import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noOnlySpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = !Array.isArray(control.value) && ((typeof control.value) === 'string') && (control?.value || '')?.trim()?.length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'noOnlySpaces': true };
  };
}